import Tippy from '@tippyjs/react';
import cogoToast from 'cogo-toast';
import moment from 'moment';
import numeral from 'numeral';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Badge, Button, OverlayTrigger, Popover } from "react-bootstrap";
import Dropdown from 'react-bootstrap/Dropdown';
import { useQuery, useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import 'tippy.js/dist/tippy.css';
import { PageTitle } from "../../../../../_metronic/layout/core";
import CardEx from '../../../../Components/Cards/CardEx';
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader";
import Semaphore from "../../../../Components/Semaphore/Semaphore";
import WrappedAgTable from "../../../../Components/Table/WrappedAgTable";
import { createCustomDateFilterParams } from '../../../../Components/Utils/Utils';
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { GeneracionCartaDesistimiento, GeneracionCartaEjecucion, GeneracionProrroga, GetDetalleGarantiasListFullWithFilter2, SaveChequeEjecucion, SaveEntregaCartaDesistimiento, SaveEntregaCartaEjecucion, SaveMomentoEntrega, UploadSustentoMomentoEntrega } from "../../../../api/Api";
import PermissionsGate from "../../../../api/PermissionsGate";
import { SCOPES } from "../../../../config/permissions-map";
import { Unauthorized } from "../../../Global/unauthorized";
import { CELL_CONSTANTS, EXCEPCION_GARANTIA_TIPO, GARANTIA_ESTADO, GARANTIA_ROL, GARANTIA_TIPO } from "../../../Utils/Constants";
import EntregaCartaModal from "../Components/EntregaCartaModal";
import ChequeGarantiaModal from './ChequeGarantiaModal';
import './Garantias.css';
import MomentoEntregaModal from './MomentoEntregaModal';

export default function ListadoGarantiasRevisiones2({ title }) {
    const gridApiRef = useRef(null);
    const columnApiRef = useRef(null);
    const currentDate = moment();
    const apiUrl = process.env.REACT_APP_API_URL;

    const user = useGetUser()

    const [showEntregaCartaEjecucionModal, setShowEntregaCartaEjecucionModal] = useState(false);
    const [isFinishEntregaCartaEjecucionSave, setIsFinishEntregaCartaEjecucionSave] = useState(false);
    const [valueEntregaCartaEjecucion, setValueEntregaCartaEjecucion] = useState(null);
    const [entregaCartaEjecucionSaveErrorMsg, setEntregaCartaEjecucionSaveErrorMsg] = useState(null);

    const idCartaEjecucion = useRef(null);

    const [showEntregaCartaDesistimientonModal, setShowEntregaCartaDesistimientoModal] = useState(false);
    const [isFinishEntregaCartaDesistimientoSave, setIsFinishEntregaCartaDesistimientoSave] = useState(false);
    const [valueEntregaCartaDesistimiento, setValueEntregaCartaDesistimiento] = useState(null);
    const [entregaCartaDesistimientoSaveErrorMsg, setEntregaCartaDesistimientoSaveErrorMsg] = useState(null);

    const idCartaDesistimiento = useRef(null);
    // const filterTipoGarantia = useRef((user.role.id === GARANTIA_ROL.REVISOR_TESORERIA) ? GARANTIA_TIPO.GAR1_CARTA_FIANZA : null)
    const filterTipoGarantia = useRef(null);
    
    const [showChequeGarantiaModal, setShowChequeGarantiaModal] = useState(false);
    const [isFinishChequeGarantiaSave, setIsFinishChequeGarantiaSave] = useState(false);
    const [valueChequeGarantia, setValueChequeGarantia] = useState(null);
    const [chequeGarantiaSaveErrorMsg, setChequeGarantiaSaveErrorMsg] = useState(null);

    const idGarantiaDetalleSelected = useRef(null);

    const [showMomentoEntegaModal, setShowMomentoEntregaModal] = useState(false);
    const [isFinishMomentoEntregaSave, setIsFinishMomentoEntregaSave] = useState(false);
    const [valueMomentoEntrega, setValueMomentoEntrega] = useState(null);
    const [momentoEntregaSaveErrorMsg, setMomentoEntregaSaveErrorMsg] = useState(null);
    const [urlFileMomentoEntregaSustento, setUrlFileMomentoEntregaSustento] = useState(null);
    const [fileNameMomentoEntregaSustento, setFileNameMomentoEntregaSustento] = useState(null);
    const [showMessageUploadLinkMomentoEntrega, setShowMessageUploadLinkMomentoEntrega] = useState(false);

    const { data: data_revisiones,
        refetch: refetch_data_revisiones,
        isFetching: isFetchingDataRevisiones,
    } = useQuery("getDetalleGarantiasListToRevision2", () => GetDetalleGarantiasListFullWithFilter2({ "tipo_garantia": filterTipoGarantia.current }));

    const handleGoToTargetRenovacion = useCallback(props => {
        if (!props) {
            return;
        }
        console.info(props.data.detalle_garantia.id_target_renovacion);
        if (gridApiRef.current) {
            const rowNode = gridApiRef.current.getRowNode(`${props.data.detalle_garantia.id_target_renovacion}`);

            if (rowNode) {
                rowNode.setSelected(true, true);
                scrollToRow(rowNode.rowIndex);
            }
        }
    }, []);

    const openModalGeneracionCarta = useCallback((props) => {
        console.info(props);
        valuesToGenerate.current = {
            "id_garantia_detalle": props.data.detalle_garantia.id_garantia_detalle,
            "updated_by": "TEMP"
        };

        setShowGenerationCartaModal(true);
    }, [])

    const openModalGeneracionCartaEjecucion = useCallback((props) => {
        console.info(props);
        valuesToGenerateCartaEjecucion.current = {
            "id_garantia_detalle": props.data.detalle_garantia.id_garantia_detalle,
            "updated_by": "TEMP"
        };

        setShowGenerationCartaEjecucionModal(true);
    }, []);

    const openModalGeneracionProrroga = useCallback((props) => {
        console.info(props);
        valuesToGenerateProrroga.current = {
            id_garantia_detalle: props.data.detalle_garantia.id_garantia_detalle,
        };

        setShowGenerationProrrogaModal(true);
    }, [])

    const handleShowEntregaCartaEjecucionModal = useCallback((event) => {
        setShowEntregaCartaEjecucionModal(true);
        idCartaEjecucion.current = event.data.detalle_garantia.ejecucion.id_carta_ejecucion;
        setValueEntregaCartaEjecucion({
            fechaLimite: event.data.detalle_garantia.ejecucion.fecha_entrega,
            estado: {
                value: event.data.detalle_garantia.ejecucion.codigo_estado_entrega,
                label: event.data.detalle_garantia.ejecucion.nombre_estado_entrega
            }
        })

    }, []);
    const handleShowEntregaCartaDesistimientoModal = useCallback((event) => {
        setShowEntregaCartaDesistimientoModal(true);
        idCartaDesistimiento.current = event.data.detalle_garantia.desistimiento.id_carta_desistimiento;
        setValueEntregaCartaDesistimiento({
            fechaLimite: event.data.detalle_garantia.desistimiento.fecha_entrega,
            estado: {
                value: event.data.detalle_garantia.desistimiento.codigo_estado_entrega,
                label: event.data.detalle_garantia.desistimiento.nombre_estado_entrega
            }
        })
    }, []);

    const handleShowChequeEjecucionModal = useCallback((event) => {
        setShowChequeGarantiaModal(true);
        idGarantiaDetalleSelected.current = event.data.detalle_garantia.id_garantia_detalle;
        setValueChequeGarantia({
            banco: {
                value: event.data.detalle_garantia.ejecucion.id_banco_cheque,
                label: event.data.detalle_garantia.ejecucion.codigo_banco_cheque
            },
            nroCheque: event.data.detalle_garantia.ejecucion.nro_cheque,
            fecha: event.data.detalle_garantia.ejecucion.fecha_ingreso_cheque
        })

    }, []);

    const handleShowMomentoEntregaModal = useCallback((event) => {
        setShowMomentoEntregaModal(true);
        idGarantiaDetalleSelected.current = event.data.detalle_garantia.id_garantia_detalle;
        setValueMomentoEntrega({
            momentoEntrega: {
                value: event.data.detalle_garantia.recepcion.codigo_momento_entrega_carta_fianza,
                label: event.data.detalle_garantia.recepcion.descripcion_momento_entrega_carta_fianza
            }
        })
        setUrlFileMomentoEntregaSustento(event.data.detalle_garantia.recepcion.url_file_name_sustento_entrega_carta_fianza || null);
        setFileNameMomentoEntregaSustento(event.data.detalle_garantia.recepcion.file_name_sustento_entrega_carta_fianza || null);
    }, []);

    const getPopover = (props) => (
        <Popover className='popover-menu'>
            {/* <Popover.Header as="h3">Cabecera!</Popover.Header> */}
            <Popover.Body>
                <ul>
                    <li>
                        <Link to={`/garantias_view/${props.data.detalle_garantia.id_garantia_detalle}`}>
                            <i className="fi fi-rr-binoculars"></i><span>Visualizar</span>
                        </Link>
                    </li>
                    {
                        props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA
                            && !props.data.detalle_garantia.revision_cobranza.id_revision_detalle_garantia
                            && !props.data.detalle_garantia.revision_tesoreria.id_revision_detalle_garantia
                            ? (<li>
                                <button className='btn' onClick={() => handleShowMomentoEntregaModal(props)}>
                                    <i className="fi fi-rr-box-alt"></i><span>Registrar Momento de entrega</span>
                                </button>

                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-box-alt"></i><span>Registrar Momento de entrega</span>
                            </li>)
                    }
                    {
                        (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.EN_REVISION 
                            && (
                                    user.role.id === GARANTIA_ROL.REVISOR_COBRANZA 
                                        || (user.role.id === GARANTIA_ROL.REVISOR_TESORERIA 
                                                && ((props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && !props.data.detalle_garantia.is_excepcion) 
                                                        ||(props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO 
                                                            && props.data.detalle_garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA))
                                            )
                                )
                                )
                            ? (<li>
                                <Link to={`/garantias_revision/${props.data.detalle_garantia.id_garantia_detalle}`}>
                                    <i className="fi fi-rr-memo-circle-check"></i> <span>Revisar Garantía</span>
                                </Link>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-memo-circle-check"></i> <span>Revisar Garantía</span>
                            </li>)
                    }
                    {
                        //props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.EN_REQUERIMIENTO_RENOVACION && 
                            props.data.detalle_garantia.is_requerida
                            //&& props.data.detalle_garantia.is_renovada
                            && !props.data.detalle_garantia.is_desistida
                            
                            ? (<li>
                                <button className='btn' onClick={() => openModalGeneracionCarta(props)}>
                                    <i className="fi fi-rr-envelope-open-text"></i> <span>Generar Carta Desistimiento</span>
                                </button>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-envelope-open-text"></i> <span>Generar Carta Desistimiento</span>
                            </li>)
                    }
                    {
                        props.data.detalle_garantia.is_requerida
                            && !props.data.detalle_garantia.is_renovada
                            && moment(props.data.detalle_garantia.fecha_vencimiento_carta_fianza).isAfter(currentDate)
                            && props.data.detalle_garantia.ejecucion.fecha_vencimiento_prorroga === null
                            ? (<li>
                                <button className='btn' onClick={() => openModalGeneracionProrroga(props)}>
                                    <i className="fi fi-rr-hand-dots"></i> <span>Generar Prórroga</span>
                                </button>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-hand-dots"></i> <span>Generar Prórroga</span>
                            </li>)
                    }
                    {
                        props.data.detalle_garantia.is_requerida
                            && !props.data.detalle_garantia.is_renovada
                            && (moment(currentDate).isAfter(props.data.detalle_garantia.ejecucion.is_prorroga ? props.data.detalle_garantia.ejecucion.fecha_vencimiento_prorroga : props.data.detalle_garantia.fecha_vencimiento_carta_fianza))
                            ? (<li>
                                <button className='btn' onClick={() => openModalGeneracionCartaEjecucion(props)}>
                                    <i className="fi fi-rr-flame"></i> <span>Generar Carta Ejecución</span>
                                </button>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-flame"></i> <span>Generar Carta Ejecución</span>
                            </li>)
                    }
                    {
                        props.data.detalle_garantia.ejecucion.id_carta_ejecucion
                            ? (<li>
                                <button className='btn' onClick={() => handleShowEntregaCartaEjecucionModal(props)}>
                                    <i className="fi fi-rr-box-alt"></i> <span>Entrega Carta Ejecución</span>
                                </button>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-box-alt"></i> <span>Generar Carta Ejecución</span>
                            </li>)
                    }
                    {
                        props.data.detalle_garantia.ejecucion.id_carta_ejecucion
                            ? (<li>
                                <button className='btn' onClick={() => handleShowChequeEjecucionModal(props)}>
                                    <i className="fi fi-rr-box-alt"></i> <span>Registrar Cheque</span>
                                </button>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-box-alt"></i> <span>Registrar Cheque</span>
                            </li>)
                    }
                    {
                        props.data.detalle_garantia.ejecucion.id_carta_ejecucion
                            ? (<li>
                                <button className='btn' onClick={() => handleShowEntregaCartaDesistimientoModal(props)}>
                                    <i className="fi fi-rr-box-open-full"></i> <span>Entregar Carta Desistimiento</span>
                                </button>
                            </li>)
                            : (<li className='disabled'>
                                <i className="fi fi-rr-box-open-full"></i> <span>Entregar Carta Desistimiento</span>
                            </li>)
                    }
                </ul>
            </Popover.Body>
        </Popover >
    );

    const header = useMemo(() => [
        {
            headerName: 'Id',
            field: 'detalle_garantia.id_garantia_detalle',
            pinned: 'left',
            width: 110,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Semáforos',
            field: 'semaforo_locatario',
            pinned: 'left',
            filter: false,
            sortable: false,
            width: 120,
            cellRenderer: (props) => props.data ? (
                <>
                    <div className="align-items-center d-flex h-100">
                        <Semaphore caption="LO" size={'25px'} fontSize={'11px'}
                            tooltipTitle={"Revisión de Locatario"}
                            lastUpdateDate={props.data.detalle_garantia?.revision_locatario?.fecha_revision}
                            lastUpdatedBy={props.data.detalle_garantia?.revision_locatario?.usuario_revisor}
                            tooltipDescription={props.data.detalle_garantia?.revision_locatario?.observaciones}
                            color={props.data.detalle_garantia.revision_locatario?.semaforo_color}>
                        </Semaphore>
                        <Semaphore caption="CO" size={'25px'} fontSize={'11px'}
                            tooltipTitle={"Revisión de Cobranza"}
                            lastUpdateDate={props.data.detalle_garantia?.revision_cobranza?.fecha_revision}
                            lastUpdatedBy={props.data.detalle_garantia?.revision_cobranza?.usuario_revisor}
                            tooltipDescription={props.data.detalle_garantia?.revision_cobranza?.observaciones}
                            color={props.data.detalle_garantia.revision_cobranza?.semaforo_color}>

                        </Semaphore>
                        {((props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && !props.data.detalle_garantia.is_excepcion) 
                            || (props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO 
                                    && props.data.detalle_garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA)) ?
                            (<Semaphore caption="TE" size={'25px'} fontSize={'11px'}
                                tooltipTitle={"Revisión de Tesorería"}
                                lastUpdateDate={props.data.detalle_garantia?.revision_tesoreria?.fecha_revision}
                                lastUpdatedBy={props.data.detalle_garantia?.revision_tesoreria?.usuario_revisor}
                                tooltipDescription={props.data.detalle_garantia?.revision_tesoreria?.observaciones}
                                color={props.data.detalle_garantia.revision_tesoreria?.semaforo_color}>
                            </Semaphore>) : null
                        }
                    </div>
                </>
            ) : <></>
        },
        {
            headerName: '',
            width: 40,
            filter: false,
            pinned: 'left',
            sortable: false,
            cellRenderer: (props) => {
                return <div className="d-flex align-items-center h-100 justify-content-center link-icon">
                    <OverlayTrigger trigger='click' placement="auto" overlay={getPopover(props)} rootClose='true'>
                        <i className="fi fi-rr-circle-ellipsis-vertical cursor-hand color-icon-blue"></i>
                    </OverlayTrigger>
                </div>;
            }
        },
        {
            headerName: 'Contrato',
            field: 'garantia.nro_contrato',
            width: 120,
            filter: 'agTextColumnFilter',
            pinned: 'left',
        },
        {
            headerName: 'Recepcionada?',
            field: 'detalle_garantia.is_recepcionada',
            width: 120,
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                var element = '';
                if (props.data.detalle_garantia.is_recepcionada === true) {
                    element = <Badge bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >Si Recepcionada</Badge>
                }
                else if (props.data.detalle_garantia.is_recepcionada === false) {
                    element = <Badge bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >No Recepcionada</Badge>
                } else {
                    element = <Badge bg="secondary">No Recepcionada</Badge>

                }

                return <div className="align-items-center d-flex h-100">{element}</div>
            },
        },
        {
            headerName: 'Renovada?',
            field: 'detalle_garantia.is_renovada',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_renovada === true) {
                    element = <Badge bg="danger">Si Renovada</Badge>
                } else {
                    element = <Badge bg="secondary">No Renovada</Badge>
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            },
        },
        {
            headerName: 'Requerida?',
            field: 'detalle_garantia.is_requerida',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_requerida === true) {
                    element = <Badge bg="danger">Si Requerida</Badge>;
                } else {
                    element = <Badge bg="secondary">No Requerida</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            },
        },
        {
            headerName: 'Desistida?',
            field: 'detalle_garantia.is_desistida',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_desistida === true) {
                    element = <Badge bg="danger">Si Desistida</Badge>;
                } else {
                    element = <Badge bg="secondary">No Desistida</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            }
        },
        {
            headerName: 'Ejecutada?',
            field: 'detalle_garantia.is_ejecutada',
            width: 100,
            //columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_ejecutada === true) {
                    element = <Badge bg="danger">Si Ejecutada</Badge>;
                } else {
                    element = <Badge bg="secondary">No Ejecutada</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            }
        },
        {
            headerName: 'Excepción?',
            field: 'detalle_garantia.is_excepcion',
            width: 100,
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                let element = '';
                if (props.data.detalle_garantia.is_excepcion === true) {
                    element = <Badge bg="danger">Con Excepción</Badge>;
                } else {
                    element = <Badge bg="secondary">Sin Excepción</Badge>;
                }
                return <div className="align-items-center d-flex h-100">{element}</div>;
            }
        },
        {
            headerName: 'Datos Generales',
            stickyLabel: false,
            children: [
                {
                    headerName: 'Origen',
                    field: 'detalle_garantia.origen.nombre',
                    width: 110
                },
                {
                    headerName: 'Estado',
                    field: 'detalle_garantia.estado.nombre',
                    width: 110,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        let element = '';
                        if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.RECHAZADO) {
                            element = <Badge bg="danger">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        } else if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.EN_REVISION) {
                            element = <Badge bg="info">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        } else if (props.data.detalle_garantia.estado.codigo === GARANTIA_ESTADO.APROBADO) {
                            element = <Badge bg="success">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        } else {
                            element = <Badge bg="secondary">{props.data.detalle_garantia.estado.nombre}</Badge>;
                        }
                        return <div className="align-items-center d-flex h-100">{element}</div>;
                    }
                },
                {
                    headerName: 'Tipo',
                    width: 120,
                    field: 'detalle_garantia.tipo_garantia.nombre',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'RUC',
                    field: 'garantia.ruc',
                    width: 120,
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Razon Social',
                    field: 'garantia.razon_social',
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Mall',
                    field: 'garantia.mall.nombre',
                    width: 160,
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Banco',
                    width: 100,
                    field: 'detalle_garantia.banco.codigo',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Importe',
                    field: 'detalle_garantia.importe',
                    type: 'rightAligned',
                    width: 100,
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                    valueFormatter: function (params) {
                        return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
                    },
                },
                {
                    headerName: 'Moneda',
                    field: 'garantia.moneda.codigo',
                    width: 100,

                },
                {
                    headerName: 'Tipo Carta Fianza',
                    field: 'detalle_garantia.descripcion_tipo_carta_fianza',
                    type: 'rightAligned',
                    width: 100,
                    //filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                    
                },
            ]
        },
        {
            headerName: 'Carta Fianza',
            stickyLabel: true,
            children: [
                {
                    headerName: 'Nro.Carta Fianza',
                    width: 160,
                    field: 'detalle_garantia.nro_carta_fianza',
                    filter: 'agTextColumnFilter',
                    filterParams: {
                        textCustomComparator: function (filter, value, filterText) {
                            //console.info(value, "<-------------value");
                        },
                    },
                    valueFormatter: function (params) {
                        return params.value == null ? CELL_CONSTANTS.NO_APLICA : params.value;
                    },
                    cellRenderer: (props) => {
                        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

                        if (cellValue == CELL_CONSTANTS.NO_APLICA) {
                            return <span className='cell-value-not-apply'>{cellValue}</span>
                        } else {
                            //return cellValue;
                            return <a href={props.data.detalle_garantia.url_filename_carta_fianza} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                                <span>{props.data.detalle_garantia.nro_carta_fianza}</span>
                            </a>;
                        }
                        // if (!props.data) {
                        //     return <></>;
                        // }
                    }
                },
                {
                    headerName: 'Venc.Carta Fianza',
                    field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 180,
                    cellClass: 'date'
                },
            ]
        },
        {
            headerName: 'Efectivo',
            stickyLabel: true,
            children: [
                {
                    headerName: 'Nro Operación',
                    field: 'detalle_garantia.nro_operacion',
                    with: 120,
                    filter: 'agTextColumnFilter',
                    enableRowGroup: false,
                    filterValueGetter: (props) => {
                        try {
                            console.info(props);
                            if (props == undefined || props.data == undefined) return null;
                            console.info(props.getValue());
                            if (props.data.detalle_garantia.tipo_garantia.codigo == GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                                return CELL_CONSTANTS.NO_APLICA;
                            } else {
                                //return props.value;
                                return props.data.detalle_garantia.nro_operacion;
                            }
                        } catch (error) {
                            console.error(error);
                            //debugger;
                        }
                    },
                    cellRenderer: (props) => {
                        try {
                            if (props == undefined || props.data == undefined) return null;
                            const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
                            if (props.data.detalle_garantia.tipo_garantia.codigo == GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                                return <span className='cell-value-not-apply'>{CELL_CONSTANTS.NO_APLICA}</span>;
                            } else {
                                //return props.value;
                                //return cellValue;
                                return <a href={props.data.detalle_garantia.url_filename_operacion} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                                    <span>{props.data.detalle_garantia.nro_operacion}</span>
                                </a>;
                            }
                        } catch (error) {
                            //debugger;
                            console.error(error);
                        }

                    },
                }
            ]
        },
        {
            headerName: 'Recepción',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Recepcionada?',
                //     field: 'detalle_garantia.is_recepcionada',
                //     width: 140,
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         var element = '';
                //         if (props.data.detalle_garantia.is_recepcionada === true) {
                //             element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >Si Recepcionada</Badge>
                //         }
                //         else if (props.data.detalle_garantia.is_recepcionada === false) {
                //             element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >No Recepcionada</Badge>
                //         } else {
                //             element = <Badge pill bg="secondary">No Recepcionada</Badge>
                //         }

                //         return <div className="align-items-center d-flex h-100">{element}</div>
                //     },
                // },
                {
                    headerName: 'Semáforo',
                    field: 'detalle_garantia.recepcion.semaforo_color',
                    //floatingFilter: false,
                    width: 70,
                    cellRenderer: (props) => props.data ? (<div className="align-items-center d-flex h-100">
                        <Semaphore
                            prefixMessage="Recepción registrada el"
                            caption=""
                            size={'25px'}
                            fontSize={'11px'}
                            tooltipTitle={"Recepción"}
                            lastUpdateDate={props.data.detalle_garantia?.recepcion?.creation_date}
                            lastUpdatedBy={props.data.detalle_garantia?.recepcion?.creation_by}
                            tooltipDescription={props.data.detalle_garantia.recepcion?.descripcion_recepcion_estado}
                            color={props.data.detalle_garantia.recepcion?.semaforo_color}>
                        </Semaphore>
                    </div>) : <></>
                },
                {
                    headerName: 'Fec.Recepción',
                    field: 'detalle_garantia.recepcion.creation_date',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 180,
                    cellClass: 'date'
                },
                {
                    headerName: 'Fec.Ing.Cuenta',
                    field: 'detalle_garantia.recepcion.fecha_ingreso_cuenta',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 180,
                    cellClass: 'date'
                }
            ]
        },
        {
            headerName: 'Renovación CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Renovada?',
                //     field: 'detalle_garantia.is_renovada',
                //     width: 120,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_renovada === true) {
                //             element = <Badge pill bg="danger">Si Renovada</Badge>
                //         } else {
                //             element = <Badge pill bg="secondary">No Renovada</Badge>
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     },
                // },
                {
                    headerName: 'Ir',
                    field: 'detalle_garantia.is_renovada',
                    width: 40,
                    filter: false,
                    sortable: false,
                    columnGroupShow: 'open',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        if (props.data.detalle_garantia.is_renovada === true) {
                            return <div className="d-flex align-items-center h-100 justify-content-center">
                                <button className="btn btn-link garantias-font d-flex align-items-center mx-2" onClick={() => handleGoToTargetRenovacion(props)} >
                                    <i className="fi fi-rr-sledding"></i>
                                </button>
                            </div>
                        } else {
                            return <></>;
                        }
                    },
                }
            ]
        },
        {
            headerName: 'Requerimiento CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Requerida?',
                //     field: 'detalle_garantia.is_requerida',
                //     width: 120,
                //     //columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_requerida === true) {
                //             element = <Badge pill bg="danger">Si Requerida</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">No Requerida</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     },
                // },
                {
                    headerName: 'Fecha. Req.',
                    field: 'detalle_garantia.requerimiento.creation_date',
                    width: 180,
                    sortable: true,
                    //columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    cellClass: 'date'
                },
                {
                    headerName: 'Nro.Carta Req.',
                    field: 'detalle_garantia.requerimiento.nro_carta_requerimiento',
                    width: 140,
                    sortable: true,
                    //columnGroupShow: 'open',
                    filter: 'agTextColumnFilter',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.requerimiento.url_file_name_carta_requerimiento} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.requerimiento.nro_carta_requerimiento}</span>
                        </a>;
                    }
                }
            ]
        },
        {
            headerName: 'Desistimiento CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Desistida?',
                //     field: 'detalle_garantia.is_desistida',
                //     width: 120,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_desistida === true) {
                //             element = <Badge pill bg="danger">Si Desistida</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">No Desistida</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     }
                // },
                {
                    headerName: 'Nro.Carta Desis.',
                    field: 'detalle_garantia.desistimiento.nro_carta_desistimiento',
                    width: 140,
                    sortable: true,
                    columnGroupShow: 'open',
                    filter: 'agTextColumnFilter',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.desistimiento.url_file_name_carta_desistimiento} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.desistimiento.nro_carta_desistimiento}</span>
                        </a>;
                    }
                },
                {
                    headerName: 'Fecha Entrega',
                    field: 'detalle_garantia.desistimiento.fecha_entrega',
                    columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 180,
                    cellClass: 'date'
                },
                {
                    headerName: 'Estado',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.desistimiento.nombre_estado_entrega',
                    width: 120
                }
            ]
        },
        {
            headerName: 'Ejecución CF',
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Ejecutada?',
                //     field: 'detalle_garantia.is_ejecutada',
                //     width: 120,
                //     columnGroupShow: 'open',
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_ejecutada === true) {
                //             element = <Badge pill bg="danger">Si Ejecutada</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">No Ejecutada</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     }
                // },
                {
                    headerName: 'Fec.Venc.Prórroga',
                    field: 'detalle_garantia.ejecucion.fecha_vencimiento_prorroga',
                    width: 180,
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    sortable: true,
                    columnGroupShow: 'open',
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    cellClass: 'date'
                },
                {
                    headerName: 'Nro.Carta Ejecu.',
                    field: 'detalle_garantia.ejecucion.nro_carta_ejecucion',
                    width: 140,
                    sortable: true,
                    columnGroupShow: 'open',
                    filter: 'agTextColumnFilter',
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.ejecucion.url_file_name_carta_ejecucion} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.ejecucion.nro_carta_ejecucion}</span>
                        </a>;
                    }
                },
                {
                    headerName: 'Fec.Entrega Carta',
                    field: 'detalle_garantia.ejecucion.fecha_entrega',
                    columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 180,
                    cellClass: 'date'
                },
                {
                    headerName: 'Estado',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.ejecucion.nombre_estado_entrega',
                    width: 120
                },
                {
                    headerName: 'Nro.Cheque',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.ejecucion.nro_cheque',
                    filter: 'agTextColumnFilter',
                    width: 120
                },
                {
                    headerName: 'Banco Cheque',
                    columnGroupShow: 'open',
                    field: 'detalle_garantia.ejecucion.codigo_banco_cheque',
                    width: 120
                },
                {
                    headerName: 'Fec.Ing.Cheque',
                    field: 'detalle_garantia.ejecucion.fecha_ingreso_cheque',
                    columnGroupShow: 'open',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    width: 180,
                    cellClass: 'date'
                },
            ]
        },
        {
            headerName: "Entrega Carta Fianza",
            stickyLabel: true,
            children: [
                {
                    headerName: 'Momento Entrega',
                    field: 'detalle_garantia.recepcion.descripcion_momento_entrega_carta_fianza',
                    width: 160,
                },
                {
                    headerName: 'Sustento',
                    field: 'detalle_garantia.recepcion.url_file_name_sustento_entrega_carta_fianza',
                    width: 150,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.recepcion.url_file_name_sustento_entrega_carta_fianza} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.recepcion.file_name_sustento_entrega_carta_fianza}</span>
                        </a>;
                    }
                },
            ]
        },
        {
            headerName: "Excepcion de Garantía",
            stickyLabel: true,
            children: [
                // {
                //     headerName: 'Excepción?',
                //     field: 'detalle_garantia.is_excepcion',
                //     width: 120,
                //     cellRenderer: (props) => {
                //         if (!props.data) {
                //             return <></>;
                //         }
                //         let element = '';
                //         if (props.data.detalle_garantia.is_excepcion === true) {
                //             element = <Badge pill bg="danger">Con Excepción</Badge>;
                //         } else {
                //             element = <Badge pill bg="secondary">Sin Excepción</Badge>;
                //         }
                //         return <div className="align-items-center d-flex h-100">{element}</div>;
                //     }
                // },
                {
                    headerName: 'Tipo',
                    field: 'detalle_garantia.excepcion.nombre_tipo_excepcion',
                    width: 160,
                },
                {
                    headerName: 'Importe',
                    field: 'detalle_garantia.excepcion.importe',
                    width: 130,
                    type: 'rightAligned',
                    filter: 'agNumberColumnFilter',
                    valueFormatter: function (params) {
                        return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
                    },
                },
                {
                    headerName: 'Fec.Vecimiento',
                    field: 'detalle_garantia.excepcion.fecha_vencimiento',
                    width: 180,
                    sortable: true,
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    },
                    cellClass: 'date'
                },
                {
                    headerName: 'Sustento',
                    field: 'detalle_garantia.excepcion.file_name_adjunto',
                    width: 150,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        return <a href={props.data.detalle_garantia.excepcion.url_file_name_adjunto} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                            <span>{props.data.detalle_garantia.excepcion.file_name_adjunto}</span>
                        </a>;
                    }
                },
            ]
        }

    ], [currentDate, handleGoToTargetRenovacion, openModalGeneracionCarta, openModalGeneracionCartaEjecucion, openModalGeneracionProrroga, handleShowEntregaCartaEjecucionModal, handleShowEntregaCartaDesistimientoModal]);

    const agGridLista = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            //defaultMinWidth: 50,
            floatingFilter: true,
            // allow every column to be grouped
            enableRowGroup: true,
        },
        columnDefs: header,
        rowData: isFetchingDataRevisiones ? undefined : data_revisiones?.data,
        pagination: true,
        paginationAutoPageSize: true,
        titleExcel: 'revision_garantias_listado',
        rowSelection: 'single',
        domLayout: "normal",
        rowGroupPanelShow: 'always',
        groupDisplayType: 'singleColumn', //singleColumn | groupRows | multipleColumns
        /** 
         * * Validar funcionamiento de=> showOpenedGroup: true,
        */
        showOpenedGroup: true,
        autoGroupColumnDef: {
            headerName: 'Grupos',
            // minWidth: 220,
            // cellRendererParams: {
            //     suppressCount: false,
            //     checkbox: false,
            // },
        },
        onGridReady: (params) => {
            gridApiRef.current = params.api;
            columnApiRef.current = params.columnApi;
        },
        getRowId: (params) => {
            return params.data.detalle_garantia.id_garantia_detalle;
        },
    }), [
        header,
        data_revisiones?.data,
        isFetchingDataRevisiones
    ]);



    //-----------------------------------

    const queryClient = useQueryClient();

    const valuesToGenerate = useRef({});
    const [showGenerationCartaModal, setShowGenerationCartaModal] = useState(false);
    const [isLoadingGenerationCarta, setIsLoadingGenerationCarta] = useState(false);
    const [isFinishGenerationCarta, setIsFinishGenerationCarta] = useState(false);

    const handleConfirmGeneration = useCallback(() => {
        setIsLoadingGenerationCarta(true);

        queryClient.fetchQuery('GeneracionCartaDesistimiento',
            () => GeneracionCartaDesistimiento({
                id_garantia_detalle: valuesToGenerate.current.id_garantia_detalle,
                updated_by: user.email
            }).then((result) => {
                if (result.data.success) {
                    console.log('Se guardo');
                }
                setIsLoadingGenerationCarta(false);
                setIsFinishGenerationCarta(true);
                refetch_data_revisiones();
            }));
    }, [queryClient, refetch_data_revisiones, user.email]);

    const handleCloseGeneration = useCallback(() => {
        setIsLoadingGenerationCarta(false);
        setIsFinishGenerationCarta(false);
    }, []);

    const valuesToGenerateCartaEjecucion = useRef({});
    const [showGenerationCartaEjecucionModal, setShowGenerationCartaEjecucionModal] = useState(false);
    const [isLoadingGenerationCartaEjecucion, setIsLoadingGenerationCartaEjecucion] = useState(false);
    const [isFinishGenerationCartaEjecucion, setIsFinishGenerationCartaEjecucion] = useState(false);

    const handleConfirmGenerationCartaEjecucion = useCallback(() => {
        setIsLoadingGenerationCartaEjecucion(true);

        queryClient.fetchQuery('generacionCartaEjecucion',
            () => GeneracionCartaEjecucion({
                id_garantia_detalle: valuesToGenerateCartaEjecucion.current.id_garantia_detalle,
                updated_by: user.email
            }).then((result) => {
                if (result.success) {
                    console.log('Se guardo');
                }
                setIsLoadingGenerationCartaEjecucion(false);
                setIsFinishGenerationCartaEjecucion(true);
                refetch_data_revisiones();
            }));
    }, [queryClient, refetch_data_revisiones, user.email]);

    const handleCloseGenerationCartaEjecucion = useCallback(() => {
        setIsLoadingGenerationCartaEjecucion(false);
        setIsFinishGenerationCartaEjecucion(false);
    }, []);

    const valuesToGenerateProrroga = useRef({});
    const [showGenerationProrrogaModal, setShowGenerationProrrogaModal] = useState(false);
    const [isLoadingGenerationProrroga, setIsLoadingGenerationProrroga] = useState(false);
    const [isFinishGenerationProrroga, setIsFinishGenerationProrroga] = useState(false);

    const handleConfirmGenerationProrroga = useCallback(() => {
        console.info(valuesToGenerate.current);
        console.info("handleConfirmGeneration");
        setIsLoadingGenerationProrroga(true);

        queryClient.fetchQuery('generacionProrroga',
            () => GeneracionProrroga({
                id_garantia_detalle: valuesToGenerateProrroga.current.id_garantia_detalle,
                updated_by: user.email
            }).then((result) => {
                if (result.success) {
                    console.log('Se guardo');
                }
                setIsLoadingGenerationProrroga(false);
                setIsFinishGenerationProrroga(true);
                refetch_data_revisiones();
            }));
    }, [queryClient, refetch_data_revisiones, user.email]);

    const handleCloseGenerationProrroga = useCallback(() => {
        setIsLoadingGenerationProrroga(false);
        setIsFinishGenerationProrroga(false);
    }, []);

    const scrollToRow = (rowIndex) => {
        const pageSize = gridApiRef.current.paginationGetPageSize();
        const currentPage = Math.floor(rowIndex / pageSize);
        gridApiRef.current.paginationGoToPage(currentPage);
    };

    const handleConfirmEntregaCartaEjecucion = useCallback((event) => {
        setIsFinishEntregaCartaEjecucionSave(false);
        const obj = {
            "id_carta_ejecucion": idCartaEjecucion.current,
            "fecha_entrega": moment(event.fechaLimite).toISOString(),
            "codigo_estado_entrega": event.estado.value,
            "updated_by": user.email
        }
        queryClient.fetchQuery('saveEntregaCartaEjecucion',
            () => SaveEntregaCartaEjecucion(obj)).then((result) => {
                if (result.status === 200) {
                    if (result.data.success) {
                        console.log('Se guardo');
                        refetch_data_revisiones({ "tipo_garantia": filterTipoGarantia.current });
                        setEntregaCartaEjecucionSaveErrorMsg(null);
                    } else {
                        setEntregaCartaEjecucionSaveErrorMsg("ERRORRR....");
                    }
                } else {
                    setEntregaCartaEjecucionSaveErrorMsg("ERRORRR....");
                }
            }).catch((err) => {
                setEntregaCartaEjecucionSaveErrorMsg("ERRORRR....");
            }).finally(() => {
                setIsFinishEntregaCartaEjecucionSave(true);
            });
    }, [queryClient, refetch_data_revisiones, user.email]);

    const handleCloseEntregaCartaEjecucion = useCallback(() => {
        setIsFinishEntregaCartaEjecucionSave(false);
        idCartaEjecucion.current = null;
        setValueEntregaCartaEjecucion(null);
        setEntregaCartaEjecucionSaveErrorMsg(null);
    }, []);

    const handleConfirmEntregaCartaDesistimiento = useCallback((event) => {
        setIsFinishEntregaCartaDesistimientoSave(false);
        const obj = {
            "id_carta_desestimiento": idCartaDesistimiento.current,
            "fecha_entrega": moment(event.fechaLimite).toISOString(),
            "codigo_estado_entrega": event.estado.value,
            "updated_by": user.email
        }
        queryClient.fetchQuery('saveEntregaCartaDesistimiento',
            () => SaveEntregaCartaDesistimiento(obj)).then((result) => {
                if (result.status === 200) {
                    if (result.data.success) {
                        console.log('Se guardo');
                        refetch_data_revisiones({ "tipo_garantia": filterTipoGarantia.current });
                        setEntregaCartaDesistimientoSaveErrorMsg(null);
                    } else {
                        setEntregaCartaDesistimientoSaveErrorMsg("ERRORRR....");
                    }
                } else {
                    setEntregaCartaDesistimientoSaveErrorMsg("ERRORRR....");
                }
            }).catch((err) => {
                setEntregaCartaDesistimientoSaveErrorMsg("ERRORRR....");
            }).finally(() => {
                setIsFinishEntregaCartaDesistimientoSave(true);
            });
    }, [queryClient, refetch_data_revisiones, user.email]);

    const handleCloseEntregaCartaDesistimiento = useCallback(() => {
        setIsFinishEntregaCartaDesistimientoSave(false);
        idCartaDesistimiento.current = null;
        setValueEntregaCartaDesistimiento(null);
        setEntregaCartaDesistimientoSaveErrorMsg(null);
    }, []);

    const handleConfirmChequeGarantia = useCallback((event) => {
        setIsFinishChequeGarantiaSave(false);
        const obj = {
            "id_garantia_detalle": idGarantiaDetalleSelected.current,
            "id_banco_cheque": event.banco.value,
            "nro_cheque": event.nroCheque,
            "fecha_ingreso_cheque": moment(event.fecha).toISOString(),
            "updated_by": user.email
        }
        queryClient.fetchQuery('saveChequeEjecucion',
            () => SaveChequeEjecucion(obj)).then((result) => {
                if (result.status === 200) {
                    if (result.data.success) {
                        console.log('Se guardo');
                        refetch_data_revisiones({ "tipo_garantia": filterTipoGarantia.current });
                        setChequeGarantiaSaveErrorMsg(null);
                    } else {
                        setChequeGarantiaSaveErrorMsg("ERRORRR....");
                    }
                } else {
                    setChequeGarantiaSaveErrorMsg("ERRORRR....");
                }
            }).catch((err) => {
                setChequeGarantiaSaveErrorMsg("ERRORRR....");
            }).finally(() => {
                setIsFinishChequeGarantiaSave(true);
            });
    }, [queryClient, refetch_data_revisiones, user.email]);

    const handleCloseChequeGarantia = useCallback(() => {
        setIsFinishChequeGarantiaSave(false);
        idGarantiaDetalleSelected.current = null;
        setValueChequeGarantia(null);
        setChequeGarantiaSaveErrorMsg(null);
    }, []);

    const uploadMomentoEntregaSustento = useCallback((file) => {
        const formData = new FormData();
        formData.append('file', file);

        queryClient.fetchQuery('uploadSustentoMomentoEntrega',
            () => UploadSustentoMomentoEntrega(formData, idGarantiaDetalleSelected.current, user.email)).then((result, response) => {
                if (result.status === 200 && result.data.success) {
                    setUrlFileMomentoEntregaSustento(result.data.data.url);
                    setFileNameMomentoEntregaSustento(result.data.data.file_name);
                    setShowMessageUploadLinkMomentoEntrega(true);
                    refetch_data_revisiones({ "tipo_garantia": filterTipoGarantia.current });
                } else {
                    setMomentoEntregaSaveErrorMsg("ERRORR ....")
                }
            }).catch(() => {
                setMomentoEntregaSaveErrorMsg("ERRORR ....")
            }).finally(() => {
                setIsFinishMomentoEntregaSave(true);
            })
    }, [queryClient, refetch_data_revisiones, user.email])

    const handleConfirmMomentoEntrega = useCallback((event, file) => {
        console.log(event)
        setIsFinishMomentoEntregaSave(false);
        const obj = {
            "id_garantia_detalle": idGarantiaDetalleSelected.current,
            "codigo_momento_entrega_carta_fianza": event.momentoEntrega.value,
            "updated_by": user.email
        }
        queryClient.fetchQuery('saveMomentoEntrega',
            () => SaveMomentoEntrega(obj)).then((result) => {
                if (result.success) {
                    console.log('Se guardo');
                    // debugger
                    if (file) {
                        uploadMomentoEntregaSustento(file);
                    } else {
                        refetch_data_revisiones({ "tipo_garantia": filterTipoGarantia.current });
                        setMomentoEntregaSaveErrorMsg(null);
                    }
                } else {
                    setMomentoEntregaSaveErrorMsg("ERRORRR....");
                }
            }).catch((err) => {
                setMomentoEntregaSaveErrorMsg("ERRORRR....");
            }).finally(() => {
                if (!file) {
                    setIsFinishMomentoEntregaSave(true);
                }
            });
    }, [queryClient, refetch_data_revisiones, uploadMomentoEntregaSustento, user.email]);


    const handleCloseMomentoEntrega = useCallback(() => {
        setIsFinishMomentoEntregaSave(false);
        idGarantiaDetalleSelected.current = null;
        setValueMomentoEntrega(null);
        setMomentoEntregaSaveErrorMsg(null);
    }, []);

    const breadcrumbs = [
        { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Garantías", path: "", isActive: false, isSeparator: false },
    ];

    // useEffect(() => {
    //     //debugger;
    //     if (data_revisiones) {
    //         console.info(data_revisiones, "data_revisiones");
    //     }
    // }, [data_revisiones]);

    // useEffect(()=> {
    //     debugger;
    // },[]);

    const handleTest = () => {
        console.info(gridApiRef.current, "gridApiRef.current");
        console.info(columnApiRef.current, "columnApiRef.current");
        columnApiRef.current.moveColumns([
            'detalle_garantia.is_recepcionada',
            'detalle_garantia.is_renovada',
            'detalle_garantia.is_requerida',
            'detalle_garantia.is_desistida',
            'detalle_garantia.is_ejecutada',
            'detalle_garantia.is_excepcion'], 0);

    }

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_REVISION_GARANTIAS_2]} >
                <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>
                <CardEx title={"Listado de Garantías"}
                    titleParent={title}
                    height={"100%"}
                    isAvailableMaximized={true}
                    isAvailableBreadcrumbs={true}
                    isAvailableRefetch={true}
                    breadcrumbs={breadcrumbs}
                    onRefetch={async () => {
                        await refetch_data_revisiones();
                        cogoToast.success('Registros actualizado satisfactoriamente!', {
                            //hideAfter: 0,
                            heading: 'Listado de Garantías',
                            position: 'top-right'
                        });
                    }} >

                    <WrappedAgTable
                        {...agGridLista} >
                        <Dropdown className='ms-2'>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic" size="sm">
                                <i className="fi fi-rr-file-excel"></i> Reportes
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href={`${apiUrl}garantias/informes/carta_data_entrega`}>Datos Retorno/Entrega</Dropdown.Item>
                                <Dropdown.Item href={`${apiUrl}garantias/informes/status_renovacion_carta_fianza`}>Status de Renovación CF</Dropdown.Item>
                                <Dropdown.Item href={`${apiUrl}garantias/informes/vencimiento_carta_fianza`}>Vencimiento de CF</Dropdown.Item>
                                <Dropdown.Item href={`${apiUrl}garantias/informes/cambio_tipo_garantia`}>Cambio de Tipo Garantía</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <div>
                            {/* <Button variant="primary" size="sm" onClick={handleTest}>Primary</Button>{' '} */}
                        </div>
                    </WrappedAgTable>
                </CardEx>
                <ConfirmWithLoader showModal={showGenerationCartaModal}
                    setShowModal={setShowGenerationCartaModal}
                    title={"Generación de Carta Notarial"}
                    isLoading={isLoadingGenerationCarta}
                    isFinish={isFinishGenerationCarta}
                    textButton={"Generar"}
                    onConfirm={handleConfirmGeneration}
                    onClose={handleCloseGeneration}>
                    {!isLoadingGenerationCarta && isFinishGenerationCarta ? (
                        <>
                            <div>La Carta de Desistimiento ha sido generada exitosamente.</div>
                        </>
                    ) : (
                        <div>Esta seguro de Generar la Carta de Desistimiento?</div>
                    )}
                </ConfirmWithLoader>

                <ConfirmWithLoader showModal={showGenerationCartaEjecucionModal}
                    setShowModal={setShowGenerationCartaEjecucionModal}
                    title={"Generación de Carta Ejecucion"}
                    isLoading={isLoadingGenerationCartaEjecucion}
                    isFinish={isFinishGenerationCartaEjecucion}
                    textButton={"Generar"}
                    onConfirm={handleConfirmGenerationCartaEjecucion}
                    onClose={handleCloseGenerationCartaEjecucion}>
                    {!isLoadingGenerationCartaEjecucion && isFinishGenerationCartaEjecucion ? (
                        <div className="d-flex align-items-center h-100">
                            <div className="d-flex align-items-center mx-2">
                                <i className="fi fi-rr-check-circle link-icon-alert"></i>
                            </div>
                            <div>
                                La Carta de Ejecución ha sido generada exitosamente.
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex align-items-center h-100">
                            <div className="d-flex align-items-center mx-2">
                                <i className="fi fi-rr-comment-question link-icon-alert"></i>
                            </div>
                            <div>
                                Está seguro de generar la Carta de Ejecución?
                            </div>
                        </div>
                    )}
                </ConfirmWithLoader>

                <ConfirmWithLoader showModal={showGenerationProrrogaModal}
                    setShowModal={setShowGenerationProrrogaModal}
                    title={"Habilitar Prorroga de Ejecución"}
                    isLoading={isLoadingGenerationProrroga}
                    isFinish={isFinishGenerationProrroga}
                    textButton={"Si"}
                    textButtonCancel="No"

                    onConfirm={handleConfirmGenerationProrroga}
                    onClose={handleCloseGenerationProrroga}>
                    {!isLoadingGenerationProrroga && isFinishGenerationProrroga ? (
                        <div className="d-flex align-items-center h-100">
                            <div className="d-flex align-items-center mx-2">
                                <i className="fi fi-rr-check-circle link-icon-alert"></i>
                            </div>
                            <div>
                                La prórroga fue habilitada exitosamente.
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex align-items-center h-100">
                            <div className="d-flex align-items-center mx-2">
                                <i className="fi fi-rr-comment-question link-icon-alert"></i>
                            </div>
                            <div>
                                Está seguro de habilitar la prórroga de ejecución de la Carta Fianza?
                            </div>
                        </div>
                    )}
                </ConfirmWithLoader>

                <EntregaCartaModal
                    title="Entrega de Carta de Ejecución"
                    showModal={showEntregaCartaEjecucionModal}
                    setShowModal={setShowEntregaCartaEjecucionModal}
                    onConfirm={handleConfirmEntregaCartaEjecucion}
                    isFinishSave={isFinishEntregaCartaEjecucionSave}
                    onClose={handleCloseEntregaCartaEjecucion}
                    value={valueEntregaCartaEjecucion}
                    messageError={entregaCartaEjecucionSaveErrorMsg}
                />
                <EntregaCartaModal
                    title="Entrega de Carta de Desistimiento"
                    showModal={showEntregaCartaDesistimientonModal}
                    setShowModal={setShowEntregaCartaDesistimientoModal}
                    onConfirm={handleConfirmEntregaCartaDesistimiento}
                    isFinishSave={isFinishEntregaCartaDesistimientoSave}
                    onClose={handleCloseEntregaCartaDesistimiento}
                    value={valueEntregaCartaDesistimiento}
                    messageError={entregaCartaDesistimientoSaveErrorMsg}
                />

                <ChequeGarantiaModal
                    title="Registro de Cheque"
                    showModal={showChequeGarantiaModal}
                    setShowModal={setShowChequeGarantiaModal}
                    onConfirm={handleConfirmChequeGarantia}
                    isFinishSave={isFinishChequeGarantiaSave}
                    onClose={handleCloseChequeGarantia}
                    value={valueChequeGarantia}
                    messageError={chequeGarantiaSaveErrorMsg}
                />
                <MomentoEntregaModal
                    title="Momento de Entrega"
                    showModal={showMomentoEntegaModal}
                    setShowModal={setShowMomentoEntregaModal}
                    onConfirm={handleConfirmMomentoEntrega}
                    isFinishSave={isFinishMomentoEntregaSave}
                    onClose={handleCloseMomentoEntrega}
                    value={valueMomentoEntrega}
                    messageError={momentoEntregaSaveErrorMsg}
                    urlFile={urlFileMomentoEntregaSustento}
                    fileName={fileNameMomentoEntregaSustento}
                    showMessageUploadLink={showMessageUploadLinkMomentoEntrega}
                    setUrlFile={setUrlFileMomentoEntregaSustento}
                    setFileName={setFileNameMomentoEntregaSustento}
                    setShowMessageUploadLink={setShowMessageUploadLinkMomentoEntrega}
                />
            </PermissionsGate>
        </>
    )
}